var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2216_4645",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.46298 18.29C8.53026 18.29 8.99836 17.5504 10.3278 17.5504C11.6572 17.5504 11.9755 18.2619 13.1552 18.2619C14.3348 18.2619 15.0931 17.1572 15.8327 16.0712C16.6566 14.826 16.9936 13.6089 17.0217 13.5528C16.9468 13.5341 14.7186 12.5885 14.7186 9.95772C14.7186 7.67335 16.4787 6.64352 16.5723 6.56862C15.4114 4.84599 13.642 4.80854 13.1645 4.80854C11.8632 4.80854 10.7959 5.62304 10.1218 5.62304C9.40093 5.62304 8.446 4.85535 7.31318 4.85535C5.15989 4.85535 2.97852 6.69033 2.97852 10.145C2.97852 12.2889 3.79302 14.5639 4.78541 16.0337C5.63736 17.2789 6.38633 18.2994 7.46298 18.2994V18.29ZM10.2061 4.60257C10.9831 4.60257 11.9662 4.05957 12.5466 3.33868C13.0709 2.68333 13.4547 1.76584 13.4547 0.848352C13.4547 0.726644 13.4454 0.595575 13.4173 0.501953C12.5466 0.539402 11.5074 1.10113 10.8802 1.85946C10.384 2.43992 9.93458 3.33868 9.93458 4.26553C9.93458 4.3966 9.9533 4.53704 9.97202 4.58385C10.0282 4.59321 10.1125 4.60257 10.2061 4.60257Z",
    fill: "#171719"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2216_4645)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#C2C4C8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.207023e8153d4f49d272b5f7e6fed82c.svg";
export { ForwardRef as ReactComponent };